/**
 * @author vishwadeep.kapoor
 * @Date: 2018-08-28 16:09:30
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-03 15:56:02
 */
/**
*
* GiftCardCart
*
*/

import React, { Component, Fragment } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { func, bool, shape, array, object } from 'prop-types';
import styled from 'styled-components';
import { Card, Row, Col } from 'antd';

import { AppWrappperHOC } from '../Root/HOC';
import { selectGiftCardCart, cartItemList, deleteCartItemStatus, select_isBoolean } from './selectors';
import Breadcrumb from '../../components/Breadcrumb';
import Container from '../../components/Container';
import CardCart from './cardCart';
import OrderSummary from '../../components/OrderSummary';
import Modal from '../../components/Modal';
import endPoints from '../../config/endPoints';
import { utils, constants, validations, fbTracker, eventTracking } from '../../devUtils';
import { fetchCartItemList, deleteCartItem, updateCartItemValues } from './actions';
import { selectUserDetails } from '../HeaderContainer/selectors';
import { ADDTOCART_PAYLOAD_STRUCTURE } from '../GiftCardsList/constants';
import Input from '../../components/Input';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import { displayLoginFrom } from '../LoginPage/actions';
import ValidationErrors from '../../components/ValidationErrors';
import { MANDATORY_FIELDS, CONSTRUCT_CART_LIST } from './constants';
import Heading from '../../components/Heading';
import { resetPopup, getUpdatedUserProfile } from '../HeaderContainer/actions';
import { selectLyraGiftCard } from '../GiftCardLanding/selectors';
import LyraCardCart from './LyracardCart';

const FormComponent = styled.div`
    margin-bottom: 20px;
    input{
    margin-bottom:0px !important;
  }
`;
class GiftCardCart extends Component {
  constructor(props) {
    super(props);
    this.cart = {};
    this.validators = validations;
    this.state = {
      userDetails: props.getUserDetails,
      cardObj: {
        cartList: [],
        orderObj: {},
      },
      lyraCardObj: {
        cartList: [],
        orderObj: {},
      },
      // userAddressObj: this.props.getUserAddress,
      item: {
        product_variation_id: '',
        quantity: 0,
        shipping_address:
        {
          email: '',
          phone_numbers: '',
        },
        free_field_value: null,
      },
      showModal: false,
      isShowValidation: false,
      // isLoadingStatus: true,
    };
    this.statelesskeys = {
      zaggle_card_client_id: '',
    };
    this.handleModal = this.handleModal.bind(this);
    this.handleChildActions = this.handleChildActions.bind(this);
    this.renderModalFooter = this.renderModalFooter.bind(this);
    this.handlePersonalDetails = this.handlePersonalDetails.bind(this);
    this.handleRedirection = this.handleRedirection.bind(this);
    this._updateValidators = this._updateValidators.bind(this);
    this.onProceedPayment = this.onProceedPayment.bind(this);
    this.onInitPayment = this.onInitPayment.bind(this);
  }

  componentWillMount() {
    const { cart } = this.state.userDetails;
    const {
      onGetCartItemsList,
      onGetUpdatedUserProfile,
      lyraGiftCardDetails,
    } = this.props;
    if (cart && cart.id) {
      this.cart = cart;
      onGetCartItemsList(cart.id);
      onGetUpdatedUserProfile();
    } else if (cart == null && cart !== undefined) {
      // this.setState({ isLoadingStatus: false });
    } else if (cart === undefined) {
      this.props.onChangeLoginModalDisplay(true);
    }
    if (lyraGiftCardDetails && Array.isArray(lyraGiftCardDetails.cartList)) {
      this.setState({ lyraCardObj: lyraGiftCardDetails });
    }
  }

  /**
   * @todo: 1) onces order is successfully placed,
   *        2) add gift card to cart, on the first render item is not showing
   *        3) till its been refreshed
   */
  componentWillReceiveProps(nextProps) {
    const { getCartItemList } = nextProps;
    // if (utils.isEqual(this.props.getCartItemList, nextProps.getCartItemList)) {
    if (getCartItemList.order) {
      const data = CONSTRUCT_CART_LIST(getCartItemList.order);
      const { zaggle_card_client_id } = getCartItemList.order;
      this.statelesskeys.zaggle_card_client_id = zaggle_card_client_id;
      this.setState({ cardObj: data });

      // Update this.cart with the cart ID to fix delete button in Lyra flow
      if (getCartItemList.order.id && !this.cart.id) {
        this.cart = { id: getCartItemList.order.id };
      }
    }
    // }
  }

  onProceedPayment() {
    const { history } = this.props;
    this.setState({ isShowModal: '' });
    utils.forceRedirect(history, { pathname: constants.LINK_ORDER_SUMMARY });
  }

  onInitPayment() {
    this.setState({ isShowModal: '' });
  }

  handleRedirection() {
    const {
      history,
      getUserDetails: {
        client_series = '',
        lyra_pg_enabled = false,
      },
    } = this.props;
    if (lyra_pg_enabled) {
      utils.forceRedirect(history, { pathname: constants.LYRA_PG_LINK_GIFTCARD_LIST });
      return;
    }
    switch (client_series) {
      case endPoints.MANIPAL_SERIES:
        utils.forceRedirect(history, { pathname: constants.LINK_CLIENT_MANIPAL });
        break;
      case endPoints.PROPEL_CORPORATE_GIFTING:
        utils.forceRedirect(history, { pathname: constants.LINK_PROPEL_CORPORATE_GIFITING_HOME });
        break;
      default:
        utils.forceRedirect(history, { pathname: constants.LINK_GIFTCARD_LIST });
        break;
    }
  }

  handleModal() {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal });
  }

  /**
   * @todo check the @constant client_id @see {cardObj:{orderObj:{client_id}}}=this.state;
   */
  handleChildActions(type, itemId, cart_obj) {
    const { history,
      getUserDetails: {
        isOnlyMerchandise = false,
        lyra_pg_enabled = false,
      } = {},
      onDeleteCartItem,
    } = this.props;
    const { id: cartId } = this.cart;
    const { zaggle_card_client_id: client_id } = this.statelesskeys;
    const category = (client_id && client_id === 'payment_gateway') ? 'Gift Cards' : 'Redeem ZSC';
    if (type === 'cont_shoping') {
      this.triggerEventTracker(category, 'Cart - Continue Shopping');
      if (itemId === 'payment_gateway' || isOnlyMerchandise || lyra_pg_enabled) {
        this.handleRedirection();
      } else {
        utils.forceRedirect(history, { pathname: constants.LINK_REDEEM_ZSC, state: { client_id: itemId, isClicked: true } });
      }
    } else if (type === 'delete') {
      this.triggerEventTracker(category, 'Cart - Delete', cart_obj);
      const dataObj = { items: [{ product_variation_id: itemId }], cartId };
      onDeleteCartItem(dataObj);
    } else if (type === 'checkOut') {
      if (lyra_pg_enabled) {
        this.setState({ isShowModal: 'REGULAR_PAYMENT' });
      } else {
        this.triggerCheckOut();
      }
    } else if (type === 'addQuantity') {
      this.triggerUpdateQuantity(itemId, cart_obj, cartId);
    } else if (type === 'editDetails') {
      const { item } = this.state;
      item.product_variation_id = cart_obj.product_variation_id;
      item.quantity = cart_obj.quantity;
      item.shipping_address = { email: cart_obj.shipping_address.email, phone_numbers: cart_obj.shipping_address.phone_numbers[0] };
      this.setState({ item });
      MANDATORY_FIELDS.forEach((element) => {
        if (element === 'phone') {
          this.validators = utils.updateValidators(this.validators, element, item.shipping_address.phone_numbers);
        } else {
          this.validators = utils.updateValidators(this.validators, element, item.shipping_address[element]);
        }
      });
      this.setState({ isShowValidation: true });
      this.handleModal();
    } else if (type === 'detailsPage') {
      const { cardObj: { orderObj: { client_id: _client_id } } } = this.state;
      history.push({
        pathname: `${constants.LINK_GIFTCARD_DETAILS}/${itemId}`,
        state: { _client_id },
      });
    }
  }

  handlePersonalDetails(type, itemId, cart_obj) {
    const { id: cartId } = this.cart;
    const { zaggle_card_client_id: client_id } = this.statelesskeys;
    const category = (client_id && client_id === 'payment_gateway') ? 'Gift Cards' : 'Redeem ZSC';
    if (type === 'updateDetails') {
      const { item } = this.state;
      if (itemId === 'email') {
        item.shipping_address.email = cart_obj;
      } else {
        item.shipping_address.phone_numbers = cart_obj;
      }
      this.setState({ item });
    } else if (type === 'saveDetails') {
      const payload = { ...ADDTOCART_PAYLOAD_STRUCTURE, item: { ...this.state.item } };
      if (utils.isFieldRequired(this.validators, MANDATORY_FIELDS)) {
        this.setState({ isShowValidation: true });
      } else {
        this.validators = utils.resetValidators(this.validators);
        this.setState({ isShowValidation: false });
        this.triggerEventTracker(category, 'Cart - Details Update');
        this.props.onChangeItemValues(payload, cartId);
        this.handleModal();
      }
    }
  }

  triggerUpdateQuantity(itemId, cart_obj, cartId) {
    const { onClearError } = this.props;
    let { quantity } = cart_obj;
    if (itemId === 'dec' && quantity === 1) {
      return;
    }
    if (itemId === 'inc') {
      quantity += 1;
    } else {
      quantity -= 1;
    }
    const payload = ADDTOCART_PAYLOAD_STRUCTURE;
    payload.item = { product_variation_id: cart_obj.product_variation_id, quantity };
    if (cart_obj.shipping_address) {
      payload.item.shipping_address = { email: cart_obj.shipping_address.email, phone_numbers: cart_obj.shipping_address.phone_numbers[0] };
    }
    if (cart_obj && cart_obj.Delivery && cart_obj.Delivery.length) {
      const cart_data = utils.lodashFind(cart_obj.Delivery, { id: cart_obj.product_variation_id });
      if (cart_data && cart_data.free_field && (quantity > cart_data.max_free_field_quantity)) {
        onClearError(`Maximum Quantity possible is ${cart_data.max_free_field_quantity}`, 'error');
      } else {
        this.props.onChangeItemValues(payload, cartId);
      }
    } else {
      this.props.onChangeItemValues(payload, cartId);
    }
  }

  /**
   * @desc here need to check the cart contains any physical vocher are there are not
   */
  triggerCheckOut() {
    const { history } = this.props;
    const { cardObj: { cartList, orderObj: { orderItemCount, orderSummeryAmount } = {} }, userDetails: { cart: { id } = {} } = {} } = this.state;
    const { zaggle_card_client_id: client_id } = this.statelesskeys;
    const category = (client_id && client_id === 'payment_gateway') ? 'Gift Cards' : 'Redeem ZSC';
    if (cartList && cartList.length > 0) {
      const result = cartList.filter(({ product_type }) => (product_type === 'physical_voucher' || product_type === 'merchandise'));
      if (result.length > 0) {
        utils.forceRedirect(history, { pathname: constants.LINK_DELHIVERY_ADDRESS });
      } else {
        utils.forceRedirect(history, { pathname: constants.LINK_ORDER_SUMMARY, state: { isClicked: true } });
      }
      // checkOut INITIATECHECKOUT
      fbTracker.INITIATE_CHECKOUT('page', id, null, orderItemCount, orderSummeryAmount);
      this.triggerEventTracker(category, 'Cart - Checkout');
    }
  }

  _updateValidators(type, value) {
    this.validators = utils.updateValidators(this.validators, type, value);
  }

  triggerEventTracker(category, actionType, label = null) {
    eventTracking.triggerEvent(category, actionType, label);
  }

  renderModalFooter() {
    return <Button onClick={() => this.handlePersonalDetails('saveDetails')}>Update</Button>;
  }

  renderPaymentButtons() {
    return (
      <Fragment>
        <Button onClick={this.onProceedPayment}>Confirm</Button>
        <Button onClick={this.onInitPayment}>Cancel</Button>
      </Fragment>
    );
  }

  renderLyraCheckoutModalUI() {
    const { isShowModal } = this.state;
    return (
      <Modal
        show={isShowModal}
        size="sm"
        showClose={this.handleModal}
        classname="default"
        classWrapper="order-modal"
        onClose={() => this.setState({ isShowModal: '' })}
        footer={this.renderPaymentButtons()}
      >
        <div className="common">
          {constants.ALERT_PAYMENT_INIT}
        </div>
      </Modal>
    );
  }

  render() {
    const {
      showModal,
      cardObj = { cartList: [] },
      lyraCardObj = { cartList: [] },
      item: {
        shipping_address,
      },
      isShowValidation,
    } = this.state;
    const {
      isLoadingStatus,
      getUserDetails: {
        isOnlyMerchandise = false,
        cart = {},
        client_series = '',
        lyra_pg_enabled = false,
      },
    } = this.props;
    if (isLoadingStatus) {
      return <Loader />;
    }
    if ((cardObj && cardObj.cartList.length > 0 && cart && cart.id)) {
      return (
        <div>
          <Breadcrumb />
          <Container>
            <Modal
              show={showModal}
              classname="default"
              header="Update Details"
              onClose={this.handleModal}
              footer={this.renderModalFooter()}
              size="sm"
            >
              <div className="formElement">
                <FormComponent>
                  <Input
                    placeholder="Email"
                    type="email"
                    value={shipping_address.email}
                    onChange={(e) => {
                      this.handlePersonalDetails('updateDetails', 'email', e.target.value);
                      this._updateValidators('email', e.target.value);
                    }}
                    required
                  />
                  {isShowValidation && ValidationErrors(this.validators, 'email')}
                </FormComponent>
                <FormComponent>
                  <Input
                    placeholder="Phone Number"
                    type="text"
                    value={shipping_address.phone_numbers}
                    onChange={(e) => {
                      this.handlePersonalDetails('updateDetails', 'phone', e.target.value);
                      this._updateValidators('phone', e.target.value);
                    }}
                    maxLength={10}
                    required
                  />
                  {isShowValidation && ValidationErrors(this.validators, 'phone')}
                </FormComponent>
              </div>
            </Modal>
            {lyra_pg_enabled && this.renderLyraCheckoutModalUI()}
            <Row align="middle" type="flex" gutter={24}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Heading title="My Cart" />
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <h2 className="nomargin">
                  <span
                    role="presentation"
                    className="pointer padding-l-2"
                    onClick={() => this.handleChildActions('cont_shoping', cardObj.client_id)}
                  >
                    Continue Shopping
                  </span>
                </h2>
              </Col>
            </Row>
            <Row align="top" type="flex" gutter={24}>
              <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                <Card className="rounded noborder noshadow">
                  {lyra_pg_enabled ?
                    <LyraCardCart
                      cartList={cardObj && cardObj.cartList}
                      orderObj={cardObj && cardObj.orderObj}
                      handleChildActions={this.handleChildActions}
                    />
                    :
                    <CardCart
                      cartList={cardObj && cardObj.cartList}
                      orderObj={cardObj && cardObj.orderObj}
                      childHandler={this.handleChildActions}
                      handleChildActions={this.handleChildActions}
                      client_series={client_series}
                    /> }
                </Card>
              </Col>
              <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                <OrderSummary orderObj={cardObj && cardObj.orderObj} childHandler={this.handleChildActions} isOnlyMerchandise={isOnlyMerchandise} client_series={client_series} lyraPgEnabled={lyra_pg_enabled} />
              </Col>
            </Row>
            <br /><br /><br />
          </Container>
        </div>
      );
    }
    return (
      <Container>
        <br />
        <div className="noresult margin-t-5">
          <img src={endPoints.ZAGGLE_CART_IMG.URL} alt={endPoints.ZAGGLE_CART_IMG.ALT} /><br clear="all" /><br />
          <p>There are no items in your cart </p>
          <Button onClick={this.handleRedirection} type="primary">Start Shopping</Button>
        </div>
      </Container>
    );
  }
}

GiftCardCart.propTypes = {
  getUserDetails: shape({}).isRequired,
  history: shape({}).isRequired,
  getCartItemList: shape({}).isRequired,
  onGetCartItemsList: func.isRequired,
  onDeleteCartItem: func.isRequired,
  onChangeItemValues: func.isRequired,
  isLoadingStatus: bool.isRequired,
  onChangeLoginModalDisplay: func.isRequired,
  onClearError: func.isRequired,
  onGetUpdatedUserProfile: func.isRequired,
  lyraGiftCardDetails: shape({
    cartList: array,
    orderObj: object,
  }),
};

GiftCardCart.defaultProps = {
  lyraGiftCardDetails: {
    cartList: [],
    orderObj: {},
  },
};

const mapDispatchToProps = (dispatch) => ({
  onGetCartItemsList: (payload) => dispatch(fetchCartItemList(payload)),
  onDeleteCartItem: (payload) => dispatch(deleteCartItem(payload)),
  onChangeItemValues: (payload, id) => dispatch(updateCartItemValues(payload, id)),
  onChangeLoginModalDisplay: (payload) => dispatch(displayLoginFrom(payload)),
  onClearError: (payload, actionType) => dispatch(resetPopup(payload, actionType)),
  onGetUpdatedUserProfile: (payload, actionType) => dispatch(getUpdatedUserProfile(payload, actionType)),
});

const mapStateToProps = createStructuredSelector({
  GiftCardCart: selectGiftCardCart(),
  getUserDetails: selectUserDetails(),
  getCartItemList: cartItemList(),
  getDeleteStatus: deleteCartItemStatus(),
  isLoadingStatus: select_isBoolean('isLoading'),
  lyraGiftCardDetails: selectLyraGiftCard('lyraGiftCardDetails'),
});

const component = connect(mapStateToProps, mapDispatchToProps)(AppWrappperHOC(GiftCardCart));
export { GiftCardCart, mapDispatchToProps, mapStateToProps };
export default component;



// WEBPACK FOOTER //
// client/containers/GiftCardCart/index.js